module.exports = __webpack_public_path__ + "img/plus.1fb0c1b8.svg";